<script>

    import { onMount, onDestroy } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import WizardStep from "../../components/wizard/wizard-step.svelte";
    import WizardFinish from "../../components/wizard/wizard-finish.svelte";
    import Wizard from "../../components/wizard/wizard.svelte";
    import Spinner from "../components/spinner.svelte";
    import Router from "../../router.js";
    import Login from "./login.svelte";
    import Configurations from "./basicconfigurations.svelte";
    import GroupsConfig from "./groupsconfig.svelte";
    import ClassroomsConfig from "./classroomsconfig.svelte";
    import ArchivalConfig from "./classroomArchival.svelte";
    import Licenses from "./licenses.svelte";
    import Summary from "./sync-summary.svelte";
    import Final  from "./finalstep.svelte";
    import Modal from "../components/modal.svelte";
    
    export let step = 0;
    export let providerId = 1;
    export let error="";
    
    let errMsg = '';
    let config;
    let mainConfig;
    let savedConfig;
    let licensesConfig;
    let isLoading = false;
    let hasCompletedFetch = false;
    let hasValidToken = false;

    let SKUs = [];
    let ServicePlans = [];
    let licenses;
    let configYears;
    let resyncBeforeUnload = false;
    let showModal = false;
    let format = /[ `!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
    let years = [];
    let groups;
    let staff = [];
    let archival;

    onDestroy(async () => {
        if (resyncBeforeUnload)
            ForceResyncSchool();
    });

    onMount(async () => {
        
        
        if(error == 'error')
            showModal = true;
        if (!step) 
            step = 1;

        await GetConfig();
        
        await GetYearsForSchool();

        await GetStaff();
        
        UpdateSavedConfig();

        if (providerId == 3 && mainConfig.accountConfig.syncPupils != null)
            await GetSKUs();
        else
            hasCompletedFetch = true;

        UpdateSavedConfig();
    });

    const GetConfig = async () => {
        let resp = await wrappedFetch(
            `/api/CloudConfig/GetConfiguration?providerId=` + providerId,
            { method: "post" }
        );
        mainConfig = await resp.json();

        console.log(mainConfig);
        

        if (!mainConfig.providerId)
        {
            mainConfig.accountConfig.providerId = providerId;
            mainConfig.groupsConfig.providerId = providerId;
            mainConfig.classesConfig.providerId = providerId;
            mainConfig.archivalConfig.providerId = providerId;
        }

        config = mainConfig.accountConfig;
        licensesConfig = mainConfig.licensesConfig;
        hasValidToken = mainConfig.hasValidToken;

    }

    const checkHasValidTokens= async () => {
        
        let resp = await wrappedFetch(
                    `/api/CloudConfig/HasvalidTokens?providerId=` + providerId,
                    { method: "post" }
                );

        hasValidToken =await resp.json(); 

        if(providerId == 1 && !hasValidToken && config.providerId != null )
        {
            let res = await wrappedFetch(
                    `/api/Cloud/RefreshGoogleToken`,
                    { method: "post" }
                );

        var token = await res.text();
        hasValidToken =  token != null || token != "";
            
        }
    }

    const GetSKUs = async () => {
        
        let resp = await wrappedFetch(`/api/cloud/GetSubscribedSKUs`, {
            method: "post",
        });

        SKUs = await resp.json();

        if (SKUs.length > 0)
        {
            if (mainConfig.isConfigured){
                // console.log(licensesConfig.staffSKUId)
                // console.log(licensesConfig.studentsSKUId)
                licensesConfig.staffSKUName =  licensesConfig.staffSKUId ? SKUs.find(x => x.skuId == licensesConfig.staffSKUId)?.skuPartNumber : "";
                licensesConfig.studentsSKUName = licensesConfig.studentsSKUId ? SKUs.find(s => s.skuId == licensesConfig.studentsSKUId)?.skuPartNumber : "";
            }
            hasCompletedFetch = true;
            await GetServicePlans();
        }
        else 
            hasCompletedFetch = true;
    };

    const GetServicePlans = async (id) => {
        
        var ids = [];
        for (var i = 0; i < SKUs.length; i++) {
            ids.push(SKUs[i].id);
        }

        let resp = await wrappedFetch("/api/cloud/GetServicePlansForSKU", {
            method: "post",
            body: JSON.stringify(ids),
            headers: {
                "Content-Type": "application/json",
            },
        });
        ServicePlans = await resp.json();
    };

    const GetYearsForSchool = async () => {

        let resp = await wrappedFetch(
                    `/api/cloudConfig/GetYearsForSchool`,
                    { method: "post" }
                );
        years = await resp.json();

    }

    const GetStaff = async () => {
        
        let resp = await wrappedFetch(
                    '/api/cloudConfig/GetStaffForSchool',
                    { method: "post" }
                );
        staff = await resp.json();
        // console.log(staff);

    }

    const Save = async () => {
        isLoading = true;
        
        if (step == "step2")
            return await SaveConfigurations();
        else if(step == "step3")
        {
            if ( (providerId == 1 && (!config.rootOrgUnit || config.rootOrgUnit == "") ) ||
                 (providerId == 3 && config.syncUSOPassword === null) )
            {
                errMsg = 'You must save basic configurations before saving groups.';
                return false;
            }   
            else
            {
                var result = await SaveGroups();
                isLoading = false;
                return result;
            }
        }
        else if(step == "step4")
        {
            var retVal = true;
            
            if(config.syncPupils && config.syncStaff) // classrooms are disabled if both pupils & staff are not being synced 
                retVal = await SaveClassrooms();
            
            // if (providerId == 3 && (!SKUs || SKUs.length == 0))
            //     await GetSKUs();

            UpdateSavedConfig();
            
            isLoading = false;
            return retVal;
        }
        else if(step == "step5")
        {
            var retVal = true;
            
            if(mainConfig.classesConfig.autoCreateClasses) // classrooms are not being synced 
                retVal = await SaveClassArchival();
            
            if (providerId == 3 && (!SKUs || SKUs.length == 0))
                await GetSKUs();

            UpdateSavedConfig();
            
            isLoading = false;
            return retVal;
        }

        isLoading = false;
        return true;
    }

    const AreObjectsEqual = (a, b) => {
        
        var falseCount = 0;
        
        Object.keys(a).forEach( (key) => {
            if (b[key] != a[key]){
                // if arrays, compare each item
                if (Array.isArray(a[key]))
                {
                    var arrayOne = a[key];
                    var arrayTwo = b[key];
                    
                    if (arrayOne.length != arrayTwo.length)
                    { 
                        falseCount++;
                    }
                    else 
                    {
                        // object at every element in arrayOne should be compared to obj at every element in arrayTwo
                        Object.keys(arrayOne).forEach( o => {

                            Object.keys(arrayOne[o]).forEach(i => {

                                Object.keys(i).every(p => {
                                    if(arrayOne[o][i] !== arrayTwo[o][i])
                                        falseCount++;
                                })
                            });
                        });
                    }
                }
                else    
                { 
                    falseCount++;
                }
            }
        });

        return falseCount > 0 ? false :  true;
    }

    const SaveConfigurations = async () => {
        
        console.log(config);
        var result = { success: true };
        
        await configYears.SaveYears();

        var areEqual = AreObjectsEqual(savedConfig.accountConfig, config );

        if (!areEqual)
        {
            config.providerId = providerId; 
            
            if(!config.syncPupils)
                config.pupilEmailFormat = '';

            if(!config.syncStaff)
                config.staffEmailFormat = '';

            if (config.syncUSOPassword ==  true)
                config.forceChangePassword = false;

            // remove empty aliases
            if (config.staffAliases != null)
                config.staffAliases = config.staffAliases.filter(element => {return element.format != ''  && element.domain != ''});
            if(config.pupilAliases != null)
                config.pupilAliases = config.pupilAliases.filter(element => {return element.format != ''  && element.domain != ''});

                if (!config.autoDeleteAccount)
                    config.deletionDelayInDays = null 

            var resp = await wrappedFetch('/api/CloudConfig/SaveConfiguration', {
                method: "post",
                body: JSON.stringify(config),
                headers: {
                    "Content-Type": "application/json",
                }
            });

            result = await resp.json();
            
            mainConfig.isConfigured = result.isComplete;

            if (!result.success)
                errMsg = result.message;
            else
                UpdateSavedConfig();

            resyncBeforeUnload = true;
        }
        isLoading = false;
        return result.success;
    }

    const SaveGroups = async () => {
        var result = { success: true };
        
        if ( AreObjectsEqual(savedConfig.groupsConfig, mainConfig.groupsConfig) == false)
        {
            mainConfig.groupsConfig.providerId = providerId;

            var resp = await wrappedFetch('/api/CloudConfig/SaveGroupsConfig', {
                method: "post",
                body: JSON.stringify(mainConfig.groupsConfig),
                headers: {
                    "Content-Type": "application/json",
                }
            });

            result = await resp.json();

            mainConfig.isConfigured = result.isComplete;

            if (!result.success)
                errMsg = result.message;
            else
                UpdateSavedConfig();

            resyncBeforeUnload = true;
        }
        isLoading = false;
        return result.success;
    }

    const SaveClassrooms = async () => {
        isLoading = true;

        var result = { success: true };

        if (AreObjectsEqual(savedConfig.classesConfig, mainConfig.classesConfig) == false)
        {
            mainConfig.classesConfig.providerId = providerId;

            
            if (!mainConfig.classesConfig.hasDefaultTeacher)
            {
                mainConfig.classesConfig.teacherPID = null;
            }

            var resp = await wrappedFetch('/api/CloudConfig/SaveClassesConfig', {
                method: "post",
                body: JSON.stringify(mainConfig.classesConfig),
                headers: {
                    "Content-Type": "application/json",
                }
            });
            result = await resp.json();
            mainConfig.isConfigured = result.isComplete;
        }
        
        isLoading = false;
        return result.success;
    }

    const SaveClassArchival = async () => {
        isLoading = true;

        var result = { success: true };

        if (AreObjectsEqual(savedConfig.archivalConfig, mainConfig.archivalConfig) == false)
        {
            mainConfig.archivalConfig.providerId = providerId;
            
            var resp = await wrappedFetch('/api/CloudConfig/SaveArchivalConfig', {
                method: "post",
                body: JSON.stringify(mainConfig.archivalConfig),
                headers: {
                    "Content-Type": "application/json",
                }
            });
            result = await resp.json();
            mainConfig.isConfigured = result.isComplete;
            
        }
        
        isLoading = false;
        return result.success;
    }

    const SaveServicePlans = async () => {
        await licenses.Save();

        UpdateSavedConfig();
    }

    const CreateRelevancyForSchool = async () => {

        var resp = await wrappedFetch(`/api/CloudConfig/CreateRelevancyForSchool?providerId=${providerId}`, {
                method: "post"            
            });
        
        var result = await resp.json();
        mainConfig.isConfigured = result.isComplete;

        UpdateSavedConfig();
    }

    const ForceResyncSchool = () => {
        wrappedFetch(`/api/cloudConfig/SuperForceResyncSchool?providerId=${providerId}`,
            { method: "post" }
        );
    }

    const ValidateConfig = () => {

        if (config) // directly going to step3 causes validation for step2 to run, which results in error
        {
            if (config.syncPupils == null)
            {
                errMsg = 'Please choose whether you want to sync students.'
                return false;
            }

            if (config.syncStaff == null)
            {
                errMsg = 'Please choose whether you want to sync staff.'
                return;
            }

            if( config.syncPupils == true && (!config.pupilDomain || config.pupilDomain == ''))
            {
                errMsg = 'You must select a domain for students';
                return;
            }

            if( config.syncPupils == true && (!config.pupilEmailFormat || config.pupilEmailFormat == ''))
            {
                errMsg = 'You must select an email format for students';
                return;
            }

            if( config.syncPupils == true && (config.pupilAliases != null && config.pupilAliases.length > 0))
            {
                config.pupilAliases.forEach(element => {
                    if (!element.format || element.format == '' || !element.domain || element.domain == '')
                    {
                        errMsg = 'You must select both format and domain for student aliases';
                        return;
                    }
                });
                
            }

            if( config.syncStaff == true && (!config.staffDomain || config.staffDomain == ''))
            {
                errMsg = 'You must select a domain for staff';
                return;
            }

            if( config.syncStaff == true && (!config.staffEmailFormat || config.staffEmailFormat == ''))
            {
                errMsg = 'You must select an email format for staff';
                return;
            }

            if( config.syncStaff == true && (config.staffAliases != null && config.staffAliases.length > 0))
            {
                config.staffAliases.forEach(element => {
                    if (!element.format || element.format == '' || !element.domain || element.domain == '')
                    {
                        errMsg = 'You must select both format and domain for staff aliases';
                        return;
                    }
                });
            }

            if (config.useLegal == null)
            {
                errMsg = 'Please choose whether you want to use legal or preferred names.'
                return;
            }

            if (config.syncUSOPassword == null)
            {
                errMsg = 'Please choose whether you want to sync USO passwords.'
                return;
            }

            if (!config.syncUSOPassword && config.forceChangePassword == null)
            {
                errMsg = 'Please choose whether you want to force users to change passwords when they first log in.'
                return;
            }

            if (providerId == 1 && (!config.rootOrgUnit || config.rootOrgUnit == ''))
            {
                errMsg = 'You must select the root organisational unit';
                return false;
            }

            if (config.autoDeleteAccount && config.deletionDelayInDays == null )
            {
                errMsg = 'Please choose number of days for auto delete';
                return;
            }
        }



        if (errMsg == '')
            return true;
    }

    const ValidateGroups = async () => {        
        groups.UpdateAdvanceGroup();

        if (providerId == 1 && (!config.rootOrgUnit || config.rootOrgUnit == ''))
            return;

        if (mainConfig.groupsConfig) // directly going to step3 causes validation for step2 to run, which results in error
        {
            if (mainConfig.groupsConfig.autoCreateGroups == null)
            {
                errMsg = 'Please choose whether you want the sync process to create basic groups.'
                return;
            }

            if (providerId == 1 && mainConfig.groupsConfig.autoCreateGroups && mainConfig.groupsConfig.supportAdvanceGroups == null)
            {
                errMsg = 'Please choose whether you want the sync process to create and maintain advance groups.'
                return;
            }

            if (providerId == 1 && mainConfig.groupsConfig.supportAdvanceGroups && !mainConfig.groupsConfig.supportRegGroups && !mainConfig.groupsConfig.supportSubjGroups)
            {
                errMsg = 'Please choose whether you want registration or subject groups.'
                return false;
            }

            if (providerId == 3 && mainConfig.groupsConfig.autoCreateGroups == true && mainConfig.groupsConfig.createO365Groups == null)
            {
                errMsg = 'Please choose whether you want Microsoft 365 groups created.'
                return;
            }

            if (mainConfig.groupsConfig.autoCreateGroups == true && mainConfig.groupsConfig.prependGroupsWithDfE == null)
            {
                errMsg = 'Please choose whether you want to prepend DfE ID to group names.'
                return;
            }

            if (mainConfig.groupsConfig.prependGroupsWithDfE && !mainConfig.groupsConfig.useDfe)
            {
                if (mainConfig.groupsConfig.prependCode == null || mainConfig.groupsConfig.prependCode == '' )
                {
                    errMsg = 'Please enter the code you want prefixed to group names.';
                    return;
                }

                if (format.test(mainConfig.groupsConfig.prependCode))
                {
                    errMsg = 'Code can not have special characters.'
                    return;
                }
            }
        }

        if (errMsg == '')
            return true;
    }

    const ValidateClasses = () => {
        if (mainConfig.classesConfig) // directly going to step3 causes validation for step2 to run, which results in error
        {
            if (mainConfig.classesConfig.autoCreateClasses == null)
            {
                errMsg = 'Please choose whether you want the sync process to create classrooms.'
                return;
            }

            if (mainConfig.classesConfig.autoCreateClasses == true && mainConfig.classesConfig.createSubjectClasses == null)
            {
                errMsg = 'Please choose whether you want to use subject or registration classes.'
                return;
            }

            if (mainConfig.classesConfig.autoCreateClasses && mainConfig.classesConfig.deleteTeachersFromClass == null)
            {
                errMsg = 'Please choose whether you want to delete teachers from classes automatically.'
                return;
            }

            if (mainConfig.classesConfig.autoCreateClasses && mainConfig.classesConfig.deletePupilsFromClass == null)
            {
                errMsg = 'Please choose whether you want to delete students from classes automatically.'
                return;
            }

            if (mainConfig.classesConfig.autoCreateClasses == true && mainConfig.groupsConfig.prependGroupsWithDfE && mainConfig.classesConfig.prependClassesWithDfE == null)
            {
                errMsg = 'Please choose whether you want to prepend DfE code to class names.'
                return;
            }

            if (mainConfig.classesConfig.hasDefaultTeacher == true && (mainConfig.classesConfig.teacherPID == null || mainConfig.classesConfig.teacherPID == 0) )
            {
                errMsg = 'Please choose a teacher to add to classrooms without any.'
                return;
            }

            if (providerId == 3 && mainConfig.classesConfig.autoCreateClasses && mainConfig.classesConfig.assignTeamsPolicyToStaff == null)
            {
                errMsg = 'Please choose whether you want to assign Teams Policy Package to staff.'
                return;
            }

            if (providerId == 3 && mainConfig.classesConfig.hasDefaultTeacher == true && (mainConfig.classesConfig.teacherPID == null || mainConfig.classesConfig.teacherPID == 0) )
            {
                errMsg = 'Please choose whether you want to assign Teams Policy Package to students.'
                return;
            }
        }

        if (errMsg == '')
            return true;
    }

    const ValidateClassArchival = () => {
        return archival.ValidateClassArchival();
    }

    const ValidateLicenses = () => {
        return licenses.ValidateLicenses();
    }

    const UpdateSavedConfig = () => {
        savedConfig = ({ 
            accountConfig : {
                providerId: providerId,
                pupilDomain: mainConfig.accountConfig.pupilDomain ?? "",
                pupilEmailFormat: mainConfig.accountConfig.pupilEmailFormat ?? "",
                pupilAliases: JSON.parse(JSON.stringify(mainConfig.accountConfig.pupilAliases)),  //deep copy array value, not just ref pointer.
                rootOrgUnit: mainConfig.accountConfig.rootOrgUnit ?? "",
                staffDomain: mainConfig.accountConfig.staffDomain ?? "",
                staffEmailFormat: mainConfig.accountConfig.staffEmailFormat ?? "",
                staffAliases: JSON.parse(JSON.stringify(mainConfig.accountConfig.staffAliases)), //[...mainConfig.accountConfig.staffAliases],
                syncPupils: mainConfig.accountConfig.syncPupils,
                syncStaff: mainConfig.accountConfig.syncStaff,
                syncUSOPassword: mainConfig.accountConfig.syncUSOPassword,
                forceChangePassword: mainConfig.accountConfig.forceChangePassword,
                useLegal: mainConfig.accountConfig.useLegal,
                titleFirst: mainConfig.accountConfig.titleFirst,
                ignoredYears: mainConfig.accountConfig.ignoredYears,
                supportABPs: mainConfig.accountConfig.supportABPs,
                autoDeleteAccount:mainConfig.accountConfig.autoDeleteAccount,
                deletionDelayInDays:mainConfig.accountConfig.deletionDelayInDays,
                usoEmailAddressFormat:mainConfig.accountConfig.usoEmailAddressFormat                 
            },
            groupsConfig : {
                providerId: providerId,
                autoCreateGroups: mainConfig.groupsConfig.autoCreateGroups,
                prependGroupsWithDfE: mainConfig.groupsConfig.prependGroupsWithDfE,
                prependCode: mainConfig.groupsConfig.prependCode,
                useDfe: mainConfig.groupsConfig.useDfe,
                dfEId: mainConfig.groupsConfig.dfEId,
                supportAdvanceGroups: mainConfig.groupsConfig.supportAdvanceGroups,
                supportRegGroups: mainConfig.groupsConfig.supportRegGroups,
                supportSubjGroups: mainConfig.groupsConfig.supportSubjGroups,
                createO365Groups: mainConfig.groupsConfig.createO365Groups
            },
            classesConfig : {
                providerId: providerId,
                autoCreateClasses: mainConfig.classesConfig.autoCreateClasses,
                createSubjectClasses: mainConfig.classesConfig.createSubjectClasses,
                prependClassesWithDfE: mainConfig.classesConfig.prependClassesWithDfE,
                deletePupilsFromClass: mainConfig.classesConfig.deletePupilsFromClass,
                deleteTeachersFromClass: mainConfig.classesConfig.deleteTeachersFromClass,
                hasDefaultTeacher: mainConfig.classesConfig.teacherPID != null && mainConfig.classesConfig.teacherPID != 0,
                teacherPID: mainConfig.classesConfig.teacherPID,
                teacherName: mainConfig.classesConfig.teacherPID != null && mainConfig.classesConfig.teacherPID != 0 ? staff.find(x => x.personId == mainConfig.classesConfig.teacherPID).name : '',
                isClassSyncPaused: mainConfig.classesConfig.isClassSyncPaused,
                assignTeamsPolicyToStaff: mainConfig.classesConfig.assignTeamsPolicyToStaff,
                assignTeamsPolicyToStudents: mainConfig.classesConfig.assignTeamsPolicyToStudents
            },
            licensesConfig : {
                disabledStaffSPs: mainConfig.licensesConfig.disabledStaffSPs,
                disabledStudentSPs: mainConfig.licensesConfig.disabledStudentSPs,
                staffSKUId: mainConfig.licensesConfig.staffSKUId,
                staffSKUName: mainConfig.licensesConfig.staffSKUName,
                studentsSKUId: mainConfig.licensesConfig.studentsSKUId,
                studentsSKUName: mainConfig.licensesConfig.studentsSKUName
            },
            archivalConfig : {
                providerId: providerId,
                isAutoArchived: mainConfig.archivalConfig.isAutoArchived,
                archiveDay: mainConfig.archivalConfig.archiveDay,
                archiveMonth: mainConfig.archivalConfig.archiveMonth,
                resumeDay: mainConfig.archivalConfig.resumeDay,
                resumeMonth: mainConfig.archivalConfig.resumeMonth
            },
            isConfigured: mainConfig.isConfigured,
            selectedYears: mainConfig.accountConfig.ignoredYears && mainConfig.accountConfig.ignoredYears.length > 0 ? 
                                years.filter( year => !mainConfig.accountConfig.ignoredYears.some(x => x.categoryId == year.categoryId)) : years,
            isPaused: mainConfig.isPaused
        });
    }
</script>
{#if showModal}
<Modal bind:showModal={showModal} sizeClass={"modal-sm"} showFooter={false}>
<div slot="header">
    <h4>Access Denied</h4>
</div>
<div slot="content">
    {#if providerId == 1}
        <p>The account used does not have enough permissions or access was denied.</p>
    {:else}
        <p>The account you used does not belong to the same tenancy/domain the sync was configured for. Please try again using an admin account from your configured domain.</p>
    {/if}
    </div>
</Modal>
{/if}
{#if config && hasCompletedFetch}
    {#if step=="summary"}
        <Summary bind:mainConfig={savedConfig}  bind:providerId  />
    {:else}
        <Wizard 
            startingStep = {step}
            bind:isLoading
            onValidate = {async (step, toValidate) => {
                errMsg='';   
                        
                if (step == 'step1')
                {
                    await checkHasValidTokens();
                    return hasValidToken;
                }
                if (step == 'step2' && providerId != 0) 
                {
                    return ValidateConfig();
                }
                if (step == 'step3')
                {   
                    if (toValidate == 'self' && config.syncPupils)
                        return await ValidateGroups();

                    return true; // groups are not necessary to configure licenses (MS).
                }
                if (step == 'step4')
                {    
                    if (config.syncStaff && config.syncPupils)
                        return ValidateClasses();

                    return true;
                }
                if (step == 'step5')
                {    
                    if (toValidate == 'self' && mainConfig.classesConfig.autoCreateClasses)
                        return ValidateClassArchival();

                    return true;
                }
                if (step == 'step6')
                {    
                    if (providerId == 3)
                        return ValidateLicenses();

                    return true;
                }
            }}
            onBeforeNavigating = { async (currentStep, nextStep, action) => {
                errMsg = '';
                if (action != 'next')
                    Router.route(`/app/export/${providerId}/${nextStep}`, false);
                return true;
            }}
            onNext = { async(currentStep, nextStep) => {
                var saveResult = await Save(currentStep);
                if (saveResult)
                  Router.route(`/export/${providerId}/${nextStep}`, true);
                return saveResult;
            }}
            onSubmit = {async() => {
                if (providerId == 1 && mainConfig.classesConfig.autoCreateClasses) //config.syncStaff && config.syncPupils
                    await SaveClassArchival(); //await SaveClassrooms();
                else if (providerId == 3)
                    await SaveServicePlans();
                
                await CreateRelevancyForSchool();
                //ForceResyncSchool(); // check super 
            }}>

            <WizardStep key="step1"
                        title="Permissions"
                        icon="fa fa-lock"
                        showNextButton={false}>
                <Login bind:providerId></Login>
            </WizardStep>
            <WizardStep key="step2"
                        title="Basic Configuration"
                        icon="fa fa-cog">
                <Configurations bind:providerId bind:config bind:errMsg bind:this={configYears} bind:years />
            </WizardStep>
            <WizardStep key="step3"
                        title="Groups"
                        icon="fa fa-users">
                <GroupsConfig bind:mainConfig bind:errMsg bind:this={groups} />
            </WizardStep>
            <WizardStep key="step4"
                        title="{providerId == 1 ? 'Classrooms' : 'Teams'}"
                        icon="fas fa-chalkboard-teacher">
                <ClassroomsConfig bind:mainConfig bind:errMsg bind:staff />
            </WizardStep>
            <WizardStep key="step5"
                        title="{providerId == 1 ? 'Classrooms' : 'Teams'} Archival"
                        icon="fa fa-archive">
                <ArchivalConfig bind:mainConfig bind:errMsg bind:this={archival} />
            </WizardStep>
            {#if providerId == 3}
            <WizardStep key="step6"
                        title="Licenses"
                        icon="far fa-object-group">
                <Licenses {SKUs} {ServicePlans} {licensesConfig} bind:this={licenses} bind:errMsg 
                    bind:syncPupils={mainConfig.accountConfig.syncPupils}
                    bind:syncStaff={mainConfig.accountConfig.syncStaff} />
            </WizardStep>
            {/if}
            <WizardFinish><Final bind:providerId /></WizardFinish>
            <!-- <WizardFinish>
                <Summary bind:config bind:providerId />
            </WizardFinish> -->
        </Wizard>
    {/if}
{:else}
    <Spinner />
{/if}
